module.exports = __webpack_public_path__ + "img/sea-5.1874e3f6.jpg";